// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/img/cc-banner.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/img/formBtn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/img/list-arrowright.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/img/location-fill.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/img/iconamoon_search.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

* {
  /* font-family: 'Roboto', sans-serif; */
  /* font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Droid Sans", "Helvetica Neue", sans-serif, "Apple Color Emoji", "color emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important; */
}
#shelly-root {
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Droid Sans", "Helvetica Neue", sans-serif, "Apple Color Emoji", "color emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

body {
  background-color: #F3F3F3 !important;
  margin: 0;
  color: rgba(0, 0, 0, 0.87);
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}

.custom-price-range-clss .MuiSlider-valueLabel {
  font-size: 0.75rem;
  padding: 0.2rem;
}

/*** Header css ****/
.banner-strip-top {
  background-color: #ffe200; /* Gray background */
  color: #000000; /* White text color */
  padding: 10px; /* Add some padding */
  text-align: center; /* Center the text */
  font-size: 14px; /* Adjust font size */
  /* font-weight: bold; Make text bold */
  /* position: fixed; Fix the banner to the top of the page */
  /* top: 0; Position it at the very top */
  /* left: 0; */
  width: 100%; /* Full width */
  z-index: 1000; /* Ensure it appears above other elements */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional shadow */
}
.header-section {
  background: linear-gradient(90deg, #25C9D0 10%, #fbee77 35%, #DB487E 90%);
  /* background: linear-gradient(to right, #25C9D0, #fbee77, #DB487E); */
  box-shadow: 0 0 3px #bcbcbc;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 999;
  padding-bottom: 3px;
  /* margin-top: 30px; */
}

.header-section-child-container-cls {
  width: 100%;
  background-color: #fff;
}
.mt-140{
  margin-top: 140px !important;
}
.header-section .logo {
  width: 120px;
  cursor: pointer;
}

.header-section .logo img {
  max-width: 100%;
}

.hero-section {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background-image: linear-gradient(0deg, rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)), Url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: -25px;
}

.hero-section .home-heading {
  font-size: 3rem;
  margin-bottom: 2rem;
  color: #fff;
  text-align: center;
  font-weight: 500;
  line-height: 4rem;
}

.hero-section .home-heading .beta-btn {
  background: #DB487E;
  border-radius: 27px;
  font-size: 1.2rem;
  color: #fff;
  padding: 2px 1rem;
  margin-left: 1rem;
}

.hero-section sup {
  top: -0.5em;
}

.hero-section .hero-search-section {
  padding: 7rem 0rem;
}

.hero-section .hero-search-section .search-card {
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(3px);
  background: rgba(204, 252, 255, .5803921569);
  height: 100%;
  cursor: pointer;
  padding: 2rem 1rem 2rem;
  text-align: center;
  border-radius: 8px;
  transition: all .3s;
  box-shadow: #00000026 0 15px 25px, #0000000d 0 5px 10px;
}

.hero-section .hero-search-section .search-card:hover {
  box-shadow: #00000029 0 1px 4px;
}

.hero-section .hero-search-section .search-card-icon {
  font-size: 5rem;
  margin: 1rem;
  color: #006c6e;
}

.hero-section .hero-search-section .search-card-title {
  font-size: 20px;
  text-shadow: 0px 0px 1px #000000;
  font-weight: 500;
  padding: 10px 0;
  margin-bottom: 0.5rem;
}

.hero-section .hero-search-section .search-card-desc {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
}

.hero-section .home-heading {
  font-size: 3rem;
  margin-bottom: 4rem;
  color: #fff;
  text-align: center;
  font-weight: 500;
  line-height: 3.5rem;
}




/* start spinner */
#cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
  display: none;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

#cover-spin::after {
  content: '';
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-color: black;
  border-top-color: transparent;
  border-width: 4px;
  border-radius: 50%;
  animation: spin .8s linear infinite;
}

/* end spinner */


.leftSideBar {
  background: #fff;
  height: calc(100vh - 60px);
  width: 0px;
  transition: width 0.3s ease-in-out;
}

.leftSideBar.open {
  width: 300px !important;
}

.leftSideBar .newChat,
.leftSideBar .newChat:hover {
  padding: 8px;
  border-radius: 16px;
  border: 1px solid #25C9D0;
  background: #25C9D0;
  font-size: 12px;
}


.menuList .ListItem {
  color: #2A3950;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  border-radius: 6px;
  padding: 2px 8px;
  margin: 0 !important;
}

.ListItemActive {
  border: 1px solid #25C9D0;
  color: #25C9D0 !important;
}

.menuList .ListItem .ListItemText span {
  font-size: 12px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  transition: transform 0.3s ease-in-out;
}

.menuList .ListItem:hover span {
  transform: translateX(5px);
  color: #25C9D0;

}

.listheading span {
  color: #343232;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 4px;
}

.travelHelp {
  bottom: 0;
  width: 100%;
  margin-top: 8rem;
}

.travelHelpcontainer {
  width: 100%;
  margin: 0 auto;
}

.travelHelp .hedding h2 {
  color: #2A3950;
  font-size: 18px;
  font-weight: 600;

}

.h6-title {
  margin-bottom: 8px;
  font-weight: 600;
}

.travelHelp .listButton {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
  margin-bottom: 10px;
  font-size: 14px;
  padding: 10px 18px;
  display: table-cell;
  float: left;
  width: 100%;
}

.travelHelp .listButton.active {
  border: 1px solid #25C9D0;
}

.listdots .List {
  display: flex;
  width: 300px;
  margin: 0 auto;
}

.chaticon img {
  margin-right: 8px;
}

.chatIcon {
  min-width: auto !important;
}

.chatIcon img {
  width: 24px;
}

.chatBg {
  background-color: #fff;
  box-shadow: 0px 2px 6px #dfdfdf;
  padding: 4px;
  display: inline-grid;
  border-radius: 0px 18px 18px 18px;
  border: 1px solid #E7E7E7;
  color: #171A1F;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 8px;
}


.chatBg h6 {
  font-size: 15px;
  color: #2A3950;
  margin-bottom: 4px;
}

.chatBg .clr-grey {
  color: #999;
  font-size: 11px;
}

.chatBg2 {
  background-color: #fff;
  box-shadow: 0px 2px 6px #dfdfdf;
  padding: 14px;
  border-radius: 18px 0px 18px 18px;
  display: inline-grid;
  float: right;

  h6 {
    font-size: 15px;
    color: #2A3950;
  }

  p {
    font-size: 12px;
    margin: 0px;
  }

  p .clr-grey {
    color: #999;
  }
}

.nav-right {
  box-shadow: 1px 1px 5px #e0e0e0 !important;
}

.listdots .dots {
  height: 8px;
  background: #D6D4D2;
  border-radius: 10px;
  margin: 0 3px;
  padding: 0;

}

.listdots .dots:hover {
  background: #25C9D0;
}

.listdots .dots.active {
  background: #25C9D0;
}

.hellowSection .icon {
  width: 82px;
  height: 82px;
  background: #fff;
  border-radius: 50%;
  line-height: 75px;
  margin: 12px auto;
}

.hellowSection h1 {
  color: #2A3950;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
}



.footerSection {
  background: #fff;
  width: calc(100% - 240px);
  padding: 20px;
  position: fixed;
  bottom: 0;
}

.grid-scroll {
  overflow: scroll;
  min-height: 440px;
}

.footerSection form {
  display: flex;
  height: 56px;
  padding: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  border: 1px solid #E7E7E7;
  background: #F3F3F3;
}

.footerSection form input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 14px;
  color: #2A3950;
}

.footerSection form .typeBtn {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) #25C9D0 no-repeat center center;
  min-width: 32px;
  height: 32px;

}

.tripDetails {
  padding: 0 !important;
  margin-bottom: 20px;
  border: 1px solid rgb(0 0 0 / 20%);
  border-radius: 6px !important;
  overflow: hidden;
  transition: all .2s ease-in-out;
  height: 187px;

}

.tripDetails .tripImg {
  overflow: hidden;
  height: 100%;
}

.tripDetails .tripImg img {
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease-in-out;
  object-fit: fill;
}

.tripDetails .tripImg img:hover {
  transform: scale(1.1);
}

.tripDetails .details {
  padding-left: 20px;
}

.tripDetails .details h2 {
  color: #000;
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  margin-bottom: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.infoText {
  font-size: 13px;
  color: #000;
}

.infoText .icon {
  font-size: 16px;
  margin-right: 5px;
  color: #000;
}

.infoText .icon.date {
  color: #db487e;
  margin-bottom: 0px;
}

.infoText .dealDates {
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  line-height: 14px;
  color: #000;
  border: 2px solid #25C9D0;
  border-radius: 5px;
  padding: 0.5rem 1.1rem;
  background: #ffffff;
  text-transform: math-auto;
}

.infoText .dealDates:hover,
.infoText .dealDates:active {
  background-color: #25C9D0 !important;
  color: #fff !important;
  border-color: #23cad3 !important;
}

.infoText .location,
.infoText .rating,
.infoText .date {
  margin-bottom: 12px;
  font-size: 13px;
  line-height: 16px;
  color: #000;


}

.rightDetails {
  font-size: 12px;
  text-align: center;
  background-color: #f6f6f6;
  height: 100%;
  border-right: 1px solid #dbdbdb;
  font-size: 11px;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rightDetails p {
  margin: 0;
}

.book-btn {
  background: #23cad3 !important;
  color: #000 !important;
  border-color: #23cad3 !important;
}

.rightDetails .book-btn {
  height: 2.7em;
  font-size: 13px;
  border: 1px solid #25C9D0;
  border-radius: 5px;
  line-height: normal;
  margin-top: 10px;
  text-transform: math-auto;

}

.price-h5 {
  font-size: 20px;
  line-height: 23px;
  color: #db487e;
  margin: 5px 0;
  display: block;
}

.nextbtn,
.nextbtn:hover {
  border-radius: 8px !important;
  background: #25C9D0 !important;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25) !important;
  color: #fff !important;
}

.custom-scroll {
  overflow-y: scroll !important;
}

.custom-scroll::-webkit-scrollbar,
.react-chatbot-kit-chat-message-container::-webkit-scrollbar {
  width: 3px !important;
}

.custom-scroll::-webkit-scrollbar-track,
.react-chatbot-kit-chat-message-container::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 18px rgba(250, 250, 251, 0.3);
  border-radius: 2px;
  margin-top: 16px;
  margin-bottom: 16px;

}

.custom-scroll::-webkit-scrollbar-thumb,
.react-chatbot-kit-chat-message-container::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #dfe2e6 !important;
  width: 6px !important;
}

.custom-scroll::-webkit-scrollbar-thumb:hover,
.react-chatbot-kit-chat-message-container::-webkit-scrollbar-thumb:hover {
  background: #757d85;
}

.aiChatbot .chatbotList {
  max-width: 500px;
  margin: 50px auto;
  margin-top: 25px;

}

.aiChatbot .chatbotList li {
  border-radius: 12px;
  background: #FFF;
  align-items: center;
  display: flex;
  list-style: none;
  gap: 15px;
  position: relative;
  border: solid 1px #fff;
}

.aiChatbot .chatbotList li .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 9px;
  background: #e8f1fc;
  width: 48px;
  height: 48px;
  transition: transform 0.3s ease-in-out;
}

.aiChatbot .chatbotList li .icon img {
  margin: 0 auto;
  border-radius: 30%;
}

.aiChatbot .chatbotList li:nth-child(1) .icon img {
  width: 20px;
}

.aiChatbot .chatbotList li:nth-child(2) .icon img {
  width: 15px;
}

.aiChatbot .chatbotList li:nth-child(3) .icon img {
  width: 32px;
}

.aiChatbot .chatbotList li p {
  color: #171A1F;
  font-size: 13px;
  transition: transform 0.3s ease-in-out;

}

.aiChatbot .chatbotList li:hover {
  border: 1px solid #25C9D0;
  box-shadow: 0px 0px 1px 0px rgba(23, 26, 31, 0.07), 0px 0px 2px 0px rgba(23, 26, 31, 0.12);
  cursor: pointer;
}

.aiChatbot .chatbotList li:hover:after {
  display: block;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 24px;
  height: 24px;
  position: absolute;
  right: 15px;
  animation: shake 1s cubic-bezier(.36, .07, .19, .97) both;

}

.aiChatbot .chatbotList li:hover p {
  transform: translateX(-10px);
}

.aiChatbot .chatbotList li:hover .icon {
  animation: shake 1s cubic-bezier(.36, .07, .19, .97) both;
}

.aiChatbot .chatbotList li:hover .icon {
  color: #fff;
}

.aiChatbot h1 {
  color: #171A1F;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
}

@keyframes shake {

  10%,
  90% {
    transform: translate3d(-0.5px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(1px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-2px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(2px, 0, 0);
  }
}

.contentSection {
  height: calc(100vh - 100px);
  padding-bottom: 14px;
}



.customChip {
  font-size: 12px !important;
}

.customChip:hover {
  box-shadow: inset 305px 0px 0px #25C9D0;
  color: #ffffff;

}

.customCalender legend {
  display: none;
}

.customCalender label,
.customRadio label {
  font-size: 14px;
}

.customCalender fieldset {
  border-color: #25C9D0;
}

.customCalender fieldset {
  padding: 8px;
  padding-top: 5px;
}

.customCalender input {
  padding: 8px;
  padding-top: 4px;
  font-size: 14px;
}

.customRadio .days {
  border-radius: 4px;
  border: 1px solid #25C9D0;
  background: #FFF;
  padding-right: 6px;
  position: relative;
  top: -4px;
  margin-left: 0;
  margin-right: 7px;
}

.customRadio .days span:nth-child(1) svg {
  width: 15px;
}

.customRadio .days span:nth-child(1) {
  padding: 4px;
}

.customRadio .days span:nth-child(2) {
  font-size: 14px;
}

.customSubmit {
  border-radius: 4px;
  border: 1px solid #25C9D0;
  background: rgba(68, 160, 188, 0.05);
  color: #25C9D0;
  transition: all 0.5s;
  cursor: pointer;
  width: 34px;
  height: 34px;
  text-align: center;
  line-height: 30px;
  margin-top: 27px;
}

.customSubmit .arrowIcon {
  display: inline-block;
  min-width: auto;
  padding: 0;

}

.customSubmit .arrowIcon:hover {
  animation: moveRight 1s infinite;
}

@keyframes moveRight {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(5px);
  }

  100% {
    transform: translateX(0);
  }
}


.customCheckBox {
  height: 32px;
  color: rgba(0, 0, 0, 0.87);
  background: #fff;
  margin-right: 10px;
  display: inline-block;
  border-radius: 32px;
  font-size: 12px;
  text-wrap: nowrap;
  align-items: center;
  padding-left: 7px;
  padding-right: 13px;
}


.customCheckBox span {
  padding: 0;
}

.customCheckBox svg {
  width: 16px !important;
}

.btn_submit {
  padding: 8px 16px !important;
  border-radius: 16px !important;
  border: 1px solid #25C9D0 !important;
  background: #25C9D0 !important;
  font-size: 12px !important;
  color: #fff !important;
  border-radius: 8px !important;
}

.rightSide {
  width: 100%;
  position: relative;
}

.rightSideChat .chaticon {
  background: #fff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  line-height: 30px;
  text-align: center;
  margin-left: 8px;

}

.rightSideChat .chaticon img {
  max-width: 60px;
  margin-right: 0;
  display: inline-block;
}


/* New chat css  */

.options {
  padding-bottom: 15px;
}

.options .options-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.options .options-container .option-item {
  display: inline-flex;
  padding: 5px 6px 5px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 9px;
  background: #E4E4E4;
  color: #565E6C;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-right: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  border: solid 1px #E4E4E4;
}

.item-active {
  color: #25C9D0 !important;
  border: solid 1px #25C9D0 !important;
  background: #fff !important;

}

.options .options-container .option-item:hover {
  color: #25C9D0;
  border: solid 1px #25C9D0;
  background: #fff;
}

.options .options-header {
  border-radius: 9px;
  background: #f0f1ff;
  display: inline-flex;
  padding: 6px 8px;
  color: #6d7fdc;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}


@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.popularPlaces h6 {
  color: #db487e;
  font-size: 11px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  font-weight: bold;
  margin-top: 8px;
}

.pplist {
  padding: 0;
  margin: 0;
  color: #25C9D0;
  font-size: 11px;
  font-weight: 400;
  line-height: 11px;
  cursor: pointer;
  text-align: left;
  list-style: none;


}

.pplist li {
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 90%;
  margin-bottom: 8px;

}

.pplist li a {
  color: #000;
  text-decoration: none !important;
}

.pplist li:hover a {
  color: #db487e;
}

.pplist li .placesIcon {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #25C9D0;
  border-radius: 50%;
  position: relative;
  top: -2px;
  margin-right: 2px;
  transition: background-color 0.5s ease, width 0.5s ease, border-radius 0.5s ease;


}

.pplist li:hover .placesIcon {
  width: 16px;
  height: 5px;
  background: #db487e;
  border-radius: 8px;
  transition: background-color 0.5s ease, width 0.5s ease, border-radius 0.5s ease;

}

.rightSide .vertical-lines {
  position: absolute;
  top: 100px;
  right: 0;
  margin-right: 12px;
  cursor: pointer;
  z-index: 1;
  display: inline-block;
}

.rightSide .vertical-lines .lines {
  border-radius: 9999px;
  height: 16px;
  width: 4px;
  background-color: #25C9D0;
  cursor: pointer;
}

.rightSide .vertical-lines .lineOne {
  transform: translateY(0.15rem) rotate(0deg);
}

.rightSide .vertical-lines .lineTwo {
  transform: translateY(-0.15rem) rotate(0deg);
}

.rightSide .vertical-lines:hover .lineOne {
  transform: translateY(0.15rem) rotate(-15deg) !important;
}

.rightSide .vertical-lines:hover .lineTwo {
  transform: translateY(-0.15rem) rotate(15deg) translateZ(0px) !important;

  position: relative;
  top: 3px;
}

.rightSide .vertical-lines:hover::after {
  content: "Close sidebar";
  position: absolute;
  background-color: #000;
  font-size: 12px;
  color: #fff;
  padding: 5px 8px;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 10px;
  top: 0;
  right: 16px;
  text-wrap: nowrap;
}

.rightSide .vertical-lines:hover::before {
  content: "";
  position: absolute;
  border-style: solid;
  border-width: 0px 8px 8px 8px;
  border-color: #000 transparent;
  display: block;
  width: 0;
  z-index: 1;
  transform: rotate(90deg);
  bottom: 13px;
  left: -18px;
}

.rightBarFull .vertical-lines:hover::after {
  content: "Open sidebar";

}

.rightBarFull .vertical-lines .lineOne,
.rightBarFull .vertical-lines:hover .lineOne {
  transform: translateY(.15rem) rotate(15deg) !important;
}

.rightBarFull .vertical-lines .lineTwo,
.rightBarFull .vertical-lines:hover .lineTwo {
  transform: translateY(.15rem) rotate(-15deg) !important;
  position: relative;
  top: -3px;
}


.rightBarFull .react-chatbot-kit-chat-input-container {
  width: calc(100% - 16px);
}

.yourOrigin .custom_Autocomplete {
  width: 200px;
}

@media (min-width:992px) and (max-width:1024px) {
  .yourOrigin .custom_Autocomplete {
    width: 150px;
  }

  .yourOrigin .custom_Autocomplete [class*="MuiAutocomplete-root"] {
    padding-right: 25px !important;
  }

}

.yourOrigin .MuiInputBase-formControl::before,
.yourOrigin .MuiInputBase-formControl::after {
  display: block;
  content: "";
  width: 18px;
  height: 18px;
  background-size: contain !important;
}

.yourOrigin .MuiInputBase-formControl::before {

  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
}

.yourOrigin .MuiInputBase-formControl::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
  position: absolute;
  right: 8px;
}

.yourOrigin .MuiAutocomplete-clearIndicator {
  position: relative;
  right: 24px;
  display: none;
}

.yourOrigin .MuiAutocomplete-popupIndicator {
  display: none;
}


.yourOrigin fieldset {
  border-radius: 8px;
}

.css-gdh49b-MuiAutocomplete-listbox .MuiAutocomplete-option {
  font-size: 14px;

}

.css-gdh49b-MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused {
  background-color: rgb(68 160 188 / 20%) !important;
}

.weather-condition-popover .ulList {
  padding-bottom: 10px !important;

}

.weather-condition-popover .weather-place-title {
  background: #db487e;
  height: 16px;
}

.weather-condition-popover li span {
  font-size: 13px;
}

.TooltipTitle {
  color: #db487e !important;
}

.demo-simple-select-label {
  position: relative;
  top: 5px;
  left: 10px;
  background: #fff;
  z-index: 1;
  display: block;
  width: 68px;
  font-size: 13px !important;
}

#header-container {
  padding: 8px 0;
}

.WeatherReportSection {
  border-bottom: solid 1px solid 1px rgb(0 0 0 / 30%);
  background-color: #F6FFFF;
  color: #000;
  padding: 16px;
  border-radius: 8px;
  position: relative;
}

.WeatherReportSection::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -10px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #F6FFFF;
  transform: translateY(-50%);
}

.placesListSection {
  padding: 16px;
  border-bottom: solid 1px solid 1px rgb(0 0 0 / 30%);
  background-color: #F6FFFF;
  color: #000;
  border-radius: 8px;
  position: relative;
}

.placesListSection::before {
  content: "";
  position: absolute;
  top: 50%;
  left: -10px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #F6FFFF;
  transform: translateY(-50%);


}

@media screen and (max-width:900px) {

  .WeatherReportSection {
    right: -18px !important;
    border-radius: 5px;

  }

  .placesListSection::before {
    content: "";
    position: inherit;
    top: none;
    left: none;
    border-top: none;
    border-bottom: none;
    border-right: none;
    transform: none;
  }


  .placesListSection::after {
    content: "";
    position: absolute;
    bottom: -14px;
    right: 14px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #F6FFFF;
    transform: translateY(50%);
    rotate: -90deg;
  }

  .placesListSection {
    bottom: -10px !important;
    border-radius: 2px;

  }

}

@media screen and (max-width:768px) {
  .WeatherReportSection {
    right: -25px !important;
  }
}


.WeatherReportSection .avg-title {
  font-size: 13px;
  font-weight: bold;
}

.WeatherReportSection .weatherConditions {
  position: relative;
}

.WeatherReportSection .weatherConditions .btn-arrow {
  font-size: 12px;
  top: 9px;
  left: -9px;
}

.WeatherReportSection .destinationName {
  width: 75px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}

.WeatherReportSection .precipitationValue {
  color: #25C9D0;
  font-size: 16px;
}

.btn-cancel {
  opacity: 1;
  color: #000;
  border-radius: 50%;
  margin: 0 0 0 auto;
  text-decoration: none;
  cursor: pointer;

}

.captchaSection {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.results-card {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  background: #ffffff;
  line-height: 1.4;
  font-family: Roboto, Helvetica Neue, sans-serif;
  border-radius: 0;
  overflow: hidden;
  z-index: 0;
}

@media (min-width: 769px) {
  .results-card {
    flex-direction: row;
  }
}

.results-card .description {
  flex-basis: 70%
}

.results-card .meta {
  flex-basis: 30%
}

.AccordionDetails {
  padding: 0 !important;
}

.price-disclmr-note {
  font-size: 9px;
  padding: 0px;
  margin: 0px;
  display: block;
}


/* Bouncing Loader */
.bouncing-loader {
  display: flex;
  justify-content: center;
  margin: 40px auto;
}

.bouncing-loader>div {
  width: 12px;
  height: 12px;
  margin: 2px 5px;
  border-radius: 50%;
  background-color: #a3a1a1;
  opacity: 1;
  animation: bouncing-loader 0.6s infinite alternate;
  margin-top: 8px;
}

@keyframes bouncing-loader {
  to {
    opacity: 0.1;
    /* transform: translateY(-16px); */
    transform: translateY(-10px);
  }
}

.bouncing-loader>div:nth-child(2) {
  animation-delay: 0.2s;
}

.bouncing-loader>div:nth-child(3) {
  animation-delay: 0.4s;
}

.bouncing-loader-conditional-cls {
  justify-content: flex-start;
  margin: 10px auto;
  margin-bottom: 4px;
}

/*** RWD css ***/


/* Mobile devices */

@media (max-width: 575px) {
  .tripDetails .details {
    padding-bottom: 8px;
  }

  .tripDetails .details h2 {
    font-size: 14px;
    white-space: inherit;
    line-height: 22px;
  }
}

@media (max-width: 768px) {

  .header-section .logo img {
    width: 80px;
  }

  .header-section .btn-cancel {
    display: none;
  }

  .hero-section .home-heading {
    font-size: 1.5rem;
    line-height: 2rem;
    margin-bottom: 2rem;
  }

  .yourOrigin .custom_Autocomplete {
    width: 150px;
  }

  .yourOrigin .custom_Autocomplete .MuiAutocomplete-input {
    padding: 1px !important;
    font-size: 12px;
  }

  .aiChatbot .chatbotList {
    max-width: 100%;
  }

  .react-chatbot-kit-chat-bot-message-container,
  .react-chatbot-kit-user-chat-message {
    max-width: 80% !important;
  }

}

@media (max-width: 992px) {

  .tripDetails {
    height: auto;
    overflow: auto;
  }

  .leftSideBar.open {
    position: absolute;
    right: 0;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);

  }

  .vertical-lines-mobile {
    display: none !important;
  }

}

@media (max-width: 1199.98px) {
  #header-container.container {
    max-width: 100% !important;
    padding: 8px 16px !important;
  }

  .travelHelpcontainer {
    width: 100%;
  }
}


/* xxl  applies to x-large devices (large desktops, less than 1400px) */
@media (max-width: 1399.98px) {}

.cursor-pointer {
  cursor: pointer;
}

iframe {
  display: none !important;
}

::-webkit-scrollbar {
  /* width: 3px !important; */
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 18px rgba(250, 250, 251, 0.3);
  border-radius: 2px;
  margin-top: 16px;
  margin-bottom: 16px;

}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #dfe2e6 !important;
  width: 6px !important;
}

::-webkit-scrollbar-thumb:hover {
  background: #757d85;
}

.disabledDiv {
  pointer-events: none !important;
  opacity: 0.8 !important;
}

.margin-top-100 {
  margin-top: 78px;
}

@media screen and (max-width:768px) {
  .margin-top-100 {
    margin-top: 61px;
  }
}

.AIslider-plus-item {
  width: 100%;
  /* min-height: 300px !important; */
  min-height: 460px !important;

  background-color: #F6F6F6 !important;
}

.plus-btn-class {
  border: 0px !important;
  background-color: transparent !important;
  cursor: pointer !important;
}

.plus-link-btn {
  text-decoration: none !important;
  cursor: pointer !important;

}



.disable-select {
  -webkit-user-select: none;
          user-select: none;
  -webkit-touch-callout: none;
}

.AIslider-plus-item {
  width: 100%;
  min-height: 440px !important;
  background-color: #ffffff !important;
}

.plus-btn-class {
  border: 0px !important;
  background-color: transparent !important;
}

.plus-link-btn {
  text-decoration: none !important;
  background-color: transparent !important;
  border: 0px !important;

}

.plus-btn-card-class {
  width: 245px;
  /* height: 190px; */
  border-radius: 10px;
  border: 2px;
  background-color: #EEFEFF;
  border-color: #25C9D0;
  border-style: dashed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}

.show-more-packages-btn-class {
  background-color: transparent;
  border: 2px solid #25C9D0;
  border-radius: 5px;
  color: #1ABCC3;
  font-size: 12px;
  font-weight: 500;
}

.show-more-packages-paragraph-class {
  color: #1ABCC3;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.preferences-radio-btn-class span {
  font-size: 12px !important;
  color: #565E6C !important;
  font-weight: 400 !important;
}

.ai-preferences-options {
  background: rgb(255, 255, 255);
  border-radius: 10px;
}

.react-datepicker-container-class .react-datepicker {
  width: 100% !important;
  border: 0px !important;
}

.react-datepicker-container-class .react-datepicker .react-datepicker__month-container {
  float: none !important;
}

@media screen and (min-width:576px) and (max-width:767px) {
  .plus-btn-card-class {
    width: 205px;
  }
}

@page {
  size: auto;
  margin: 20px;
  border-radius: 16px;
  background: #F5F6FA;
  padding-bottom: 16px;
  padding-top: 30px;
  padding-left: 20px;
  position: relative;
  flex: 1 1 auto;
}

@media print {
  .row {
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1* var(--bs-gutter-y));
    margin-right: calc(-0.5* var(--bs-gutter-x));
    margin-left: calc(-0.5* var(--bs-gutter-x));
  }

  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .heading-grid {
    color: #000;
    font-size: 14px;
    margin-bottom: 24px;
    margin-left: 1.5rem;
  }

  .gap-3 {
    gap: 1rem !important;
  }

  .d-flex {
    display: flex !important;
  }

  .custom-stepper {
    width: 100%;
  }

  .custom-stepper .stepper-item {
    list-style: none;
    height: 100%;
    position: relative;
    width: 100%;
  }

  .custom-stepper .stepper-item::after {
    content: '';
    height: 100%;
    border: dashed 1px rgb(0 0 0 / 50%);
    width: 1px;
    display: block;
    position: absolute;
    top: 17px;
    left: 12px;
  }

  .custom-stepper .stepper-item .stepper-icon .icon {
    z-index: 1;
    position: relative;
    width: 26px;
    height: 26px;
    border-radius: 20px;
    background-color: #DB487E;
    color: #fff;
    text-align: center;
  }

  .custom-stepper .stepper-item .stepper-icon .icon:before {
    z-index: 0;
    content: '';
    position: absolute;
    top: 19px;
    left: 50%;
    margin-left: -12px;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 20px solid #DB487E;
  }

  .custom-stepper .stepper-item .stepper-icon .icon span {
    position: relative;
    top: 5px;
    font-size: 13px;
  }

  .custom-stepper .last-item::after {
    display: none !important
  }


  .dragging-box .custom-stepper .stepper-item::after {
    display: none !important
  }

  .dragging-box .custom-stepper .stepper-item .trip-duration {
    display: none !important
  }

  .dragging-box .custom-stepper .stepper-item .stepper-content .trip-card .description {
    border-color: #25C9D0;
  }

  .custom-stepper .stepper-item .stepper-content {
    width: 100%;
  }

  .custom-stepper .stepper-item .stepper-content::after {
    content: '';
    height: 100%;
    width: 2px;
    background-color: red;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card {
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    line-height: 1.4;
    border-radius: 0;
    overflow: hidden;
    z-index: 0;
  }

  @media (min-width: 769px) {
    .custom-stepper .stepper-item .stepper-content .trip-card {
      flex-direction: row;
    }
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description {
    flex-basis: 85%;
    background: #fff;
    border-radius: 16px;
    border: 1px solid #E4E4E4;
    background: #FFF;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .meta {
    flex-basis: 15%
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description h2 {
    color: #DB487E;
    text-align: center;
    font-size: 0.9em;
    font-weight: 700;
    letter-spacing: 0.5px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .draggable-icon {
    position: absolute;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .title {
    color: #000;
    font-size: 14px;
    font-weight: 600;
    line-height: 16.412px;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .dec {
    color: #4A4A4A;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.15px;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .price-book {
    position: relative;
    top: 50%;
    transform: translate(0%, -50%);
    align-items: center;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .price-book .price {
    color: #DB487E;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 16.412px;
    margin-bottom: 8px;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .price-book .book-btn {
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16.412px;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .border-right {
    border-right: solid 1px #DFDFDF;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons {
    position: relative;
    color: #7A7C7D;
    font-size: 12px;
    font-weight: 400;
    margin-right: 16px;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons .activity-time {
    color: #000;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    margin: 10px 0
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons::before {
    content: "";
    display: block;
    height: 62%;
    position: absolute;
    top: 16px;
    left: 7px;
    border: dashed 1px #DFDFDF;
    margin-right: 0;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons .timer-bottom,
  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons .timer-top {

    font-size: 15px;
    color: #DB487E;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .meta .image-grid {
    border-radius: 16px;
    border: 1px solid #E4E4E4;
    overflow: hidden;
    position: relative;
    width: 190px;
    height: 137px;
    transition: transform 0.3s ease-in-out;

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);

      img {
        transform: scale(1.1);
      }
    }
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .meta .image-grid img {
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease-in-out;

  }

  .custom-stepper .stepper-item .stepper-content .trip-card .meta .image-grid .image-info {
    position: absolute;
    bottom: 0;
    padding: 8px;
    width: 100%;
    border-radius: 0px 0px 16px 16px;
    background: rgb(0 0 0 / 50%);
    color: #FFF;
    font-size: 11px;
    font-weight: 400;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .meta .del-edit-icons {
    width: 16px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

  }

  .custom-stepper .stepper-item .stepper-content .trip-card:hover .meta .del-edit-icons {
    width: 16px;
    opacity: 1;
    visibility: visible;
  }


  .custom-stepper .stepper-item .stepper-content .trip-card .meta .del-edit-icons button {
    min-width: auto;
    padding: 0;
    font-size: 20px;
  }

  .custom-stepper .stepper-item .stepper-content .trip-card .meta .del-edit-icons .btn-del-icon {
    width: 20px;
    height: 20px;
    color: #DB487E;
  }



  .custom-stepper .stepper-item .stepper-content .trip-card .meta .del-edit-icons .btn-edit-icon {
    color: #4dd2d7;
  }

  .custom-stepper .stepper-item .stepper-content .trip-duration {
    color: #070F1D;
    font-size: 14px;
    font-weight: 400;
    height: 70px;
    position: relative;
    padding-top: 25px;
    padding-left: 129px;
  }

  .custom-stepper .stepper-item .stepper-content .trip-duration::before {
    content: "";
    height: 100%;
    display: block;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
    border: dashed 1px #C2C2C2;
    width: 1px;
  }


  .custom-stepper .stepper-item .stepper-content .trip-duration .car {
    width: 36px;
    height: 20px;
    display: flex;
    justify-content: space-between;
  }

  .custom-stepper .stepper-item .stepper-content .trip-duration .wheel {
    position: relative;
    animation: spin 5s linear infinite;
  }

  .custom-stepper .stepper-item .stepper-content .trip-duration .wheel-one {
    left: 2px;
    top: 11px;
    animation: spin 5s linear infinite;
    position: relative;
  }

  .custom-stepper .stepper-item .stepper-content .trip-duration .wheel-two {
    left: -2px;
    top: 11px;
    position: relative;
    animation: spin 5s linear infinite;

  }

}

.disable-del-edit-icons {
  display: none !important;
  opacity: 0 !important;
}

@media screen and (min-width:993px) {
  .trip-mobile-menu-icon {
    display: none;
  }
}

@media screen and (max-width:450px) {
  .mobile-padding-cls {
    padding-left: 5px !important;
    padding-right: 5px !important;

  }
}


.highlight-card {
  border: 2px solid #007bff;
  background: #f0f8ff;
}
.button.chatbot-chat-btn-send.mic-icon {
  right: 46px;
}

/* .button.chatbot-chat-btn-send.mic-icon svg {
  font-size: 20px;
} */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,0MAA0M;AAC5M;AACA;EACE,oMAAoM;AACtM;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oCAAoC;EACpC,SAAS;EACT,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc,EAAE,qBAAqB;EACrC,aAAa,EAAE,qBAAqB;EACpC,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,qBAAqB;EACtC,sCAAsC;EACtC,2DAA2D;EAC3D,wCAAwC;EACxC,aAAa;EACb,WAAW,EAAE,eAAe;EAC5B,aAAa,EAAE,2CAA2C;EAC1D,wCAAwC,EAAE,oBAAoB;AAChE;AACA;EACE,yEAAyE;EACzE,sEAAsE;EACtE,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sHAAsH;EACtH,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,4CAA4C;EAC5C,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;;;;AAKA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,aAAa;AACf;;AAYA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAElB,mCAAmC;AACrC;;AAEA,gBAAgB;;;AAGhB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;;AAEhB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,aAAa;EACb,iCAAiC;EACjC,oBAAoB;EACpB,YAAY;;EAEZ;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,UAAU;;AAEZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;;;AAIA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mFAA8E;EAC9E,eAAe;EACf,YAAY;;AAEd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;;AAEf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;;EAGE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;;;AAGb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;;AAE3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;EAC7B,8BAA8B;EAC9B,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,2DAA2D;EAE3D,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;;EAGE,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sCAAsC;;AAExC;;AAEA;EACE,yBAAyB;EACzB,0FAA0F;EAC1F,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yDAAuD;EACvD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yDAAyD;;AAE3D;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE;;IAEE,oCAAoC;EACtC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;;IAGE,kCAAkC;EACpC;;EAEA;;IAEE,iCAAiC;EACnC;AACF;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;;;AAIA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,cAAc;;AAEhB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,UAAU;;AAEZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;;AAGA;EACE,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;;AAGA,kBAAkB;;AAElB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;;AAE7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;;AAGlB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,gFAAgF;;;AAGlF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gFAAgF;;AAElF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,wEAAwE;;EAExE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;EACd,QAAQ;EACR,UAAU;EACV,wBAAwB;EACxB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;;AAEzB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;;EAEE,uDAAuD;EACvD,kBAAkB;EAClB,SAAS;AACX;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;AAEF;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;;EAEE,6DAA8D;AAChE;;AAEA;EACE,6DAAiE;EACjE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;;AAEjC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;;;AAG7B;;AAEA;;EAEE;IACE,uBAAuB;IACvB,kBAAkB;;EAEpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;;EAGA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,kCAAkC;IAClC,qCAAqC;IACrC,gCAAgC;IAChC,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;;EAEpB;;AAEF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;;AAGA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;;AAEzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;;AAGA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,kCAAkC;IAClC,4BAA4B;EAC9B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gBAAgB;;;AAGhB,mBAAmB;;AAEnB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,oBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;;EAEE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,yBAAyB;EAC3B;;AAEF;;AAEA;;EAEE;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,6CAA6C;;EAE/C;;EAEA;IACE,wBAAwB;EAC1B;;AAEF;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA,uEAAuE;AACvE,+BAA+B;;AAE/B;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2DAA2D;EAE3D,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;EAEE,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,4BAA4B;;EAE5B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;;AAE5B;;;;AAIA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,sBAAsB;;AAExB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,wCAAwC;IACxC,4CAA4C;IAC5C,2CAA2C;EAC7C;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE;EACF;;;EAGA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE;EACF;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;EACF;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sCAAsC;;IAEtC;MACE,oCAAoC;;MAEpC;QACE,qBAAqB;MACvB;IACF;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sCAAsC;;EAExC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,iEAAiE;;EAEnE;;EAEA;IACE,WAAW;IACX,UAAU;IACV,mBAAmB;EACrB;;;EAGA;IACE,eAAe;IACf,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;;;EAIA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,8BAA8B;IAC9B,0BAA0B;IAC1B,UAAU;EACZ;;;EAGA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,SAAS;IACT,SAAS;IACT,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,kCAAkC;;EAEpC;;AAEF;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,6BAA6B;;EAE/B;AACF;;;AAGA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;;GAEG","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n* {\n  /* font-family: 'Roboto', sans-serif; */\n  /* font-family: BlinkMacSystemFont, -apple-system, \"Segoe UI\", \"Roboto\", \"Droid Sans\", \"Helvetica Neue\", sans-serif, \"Apple Color Emoji\", \"color emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !important; */\n}\n#shelly-root {\n  font-family: BlinkMacSystemFont, -apple-system, \"Segoe UI\", \"Roboto\", \"Droid Sans\", \"Helvetica Neue\", sans-serif, \"Apple Color Emoji\", \"color emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !important;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nbody {\n  background-color: #F3F3F3 !important;\n  margin: 0;\n  color: rgba(0, 0, 0, 0.87);\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5;\n  letter-spacing: 0.00938em;\n}\n\n.custom-price-range-clss .MuiSlider-valueLabel {\n  font-size: 0.75rem;\n  padding: 0.2rem;\n}\n\n/*** Header css ****/\n.banner-strip-top {\n  background-color: #ffe200; /* Gray background */\n  color: #000000; /* White text color */\n  padding: 10px; /* Add some padding */\n  text-align: center; /* Center the text */\n  font-size: 14px; /* Adjust font size */\n  /* font-weight: bold; Make text bold */\n  /* position: fixed; Fix the banner to the top of the page */\n  /* top: 0; Position it at the very top */\n  /* left: 0; */\n  width: 100%; /* Full width */\n  z-index: 1000; /* Ensure it appears above other elements */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional shadow */\n}\n.header-section {\n  background: linear-gradient(90deg, #25C9D0 10%, #fbee77 35%, #DB487E 90%);\n  /* background: linear-gradient(to right, #25C9D0, #fbee77, #DB487E); */\n  box-shadow: 0 0 3px #bcbcbc;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 999;\n  padding-bottom: 3px;\n  /* margin-top: 30px; */\n}\n\n.header-section-child-container-cls {\n  width: 100%;\n  background-color: #fff;\n}\n.mt-140{\n  margin-top: 140px !important;\n}\n.header-section .logo {\n  width: 120px;\n  cursor: pointer;\n}\n\n.header-section .logo img {\n  max-width: 100%;\n}\n\n.hero-section {\n  position: relative;\n  min-height: 100vh;\n  overflow: hidden;\n  background-image: linear-gradient(0deg, rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)), Url(\"../src/assets/img/cc-banner.jpeg\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  margin-bottom: -25px;\n}\n\n.hero-section .home-heading {\n  font-size: 3rem;\n  margin-bottom: 2rem;\n  color: #fff;\n  text-align: center;\n  font-weight: 500;\n  line-height: 4rem;\n}\n\n.hero-section .home-heading .beta-btn {\n  background: #DB487E;\n  border-radius: 27px;\n  font-size: 1.2rem;\n  color: #fff;\n  padding: 2px 1rem;\n  margin-left: 1rem;\n}\n\n.hero-section sup {\n  top: -0.5em;\n}\n\n.hero-section .hero-search-section {\n  padding: 7rem 0rem;\n}\n\n.hero-section .hero-search-section .search-card {\n  -webkit-backdrop-filter: blur(2px);\n  backdrop-filter: blur(3px);\n  background: rgba(204, 252, 255, .5803921569);\n  height: 100%;\n  cursor: pointer;\n  padding: 2rem 1rem 2rem;\n  text-align: center;\n  border-radius: 8px;\n  transition: all .3s;\n  box-shadow: #00000026 0 15px 25px, #0000000d 0 5px 10px;\n}\n\n.hero-section .hero-search-section .search-card:hover {\n  box-shadow: #00000029 0 1px 4px;\n}\n\n.hero-section .hero-search-section .search-card-icon {\n  font-size: 5rem;\n  margin: 1rem;\n  color: #006c6e;\n}\n\n.hero-section .hero-search-section .search-card-title {\n  font-size: 20px;\n  text-shadow: 0px 0px 1px #000000;\n  font-weight: 500;\n  padding: 10px 0;\n  margin-bottom: 0.5rem;\n}\n\n.hero-section .hero-search-section .search-card-desc {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.hero-section .home-heading {\n  font-size: 3rem;\n  margin-bottom: 4rem;\n  color: #fff;\n  text-align: center;\n  font-weight: 500;\n  line-height: 3.5rem;\n}\n\n\n\n\n/* start spinner */\n#cover-spin {\n  position: fixed;\n  width: 100%;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 9999;\n  display: none;\n}\n\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n#cover-spin::after {\n  content: '';\n  display: block;\n  position: absolute;\n  left: 48%;\n  top: 40%;\n  width: 40px;\n  height: 40px;\n  border-style: solid;\n  border-color: black;\n  border-top-color: transparent;\n  border-width: 4px;\n  border-radius: 50%;\n  -webkit-animation: spin .8s linear infinite;\n  animation: spin .8s linear infinite;\n}\n\n/* end spinner */\n\n\n.leftSideBar {\n  background: #fff;\n  height: calc(100vh - 60px);\n  width: 0px;\n  transition: width 0.3s ease-in-out;\n}\n\n.leftSideBar.open {\n  width: 300px !important;\n}\n\n.leftSideBar .newChat,\n.leftSideBar .newChat:hover {\n  padding: 8px;\n  border-radius: 16px;\n  border: 1px solid #25C9D0;\n  background: #25C9D0;\n  font-size: 12px;\n}\n\n\n.menuList .ListItem {\n  color: #2A3950;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n  border-radius: 6px;\n  padding: 2px 8px;\n  margin: 0 !important;\n}\n\n.ListItemActive {\n  border: 1px solid #25C9D0;\n  color: #25C9D0 !important;\n}\n\n.menuList .ListItem .ListItemText span {\n  font-size: 12px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  transition: transform 0.3s ease-in-out;\n}\n\n.menuList .ListItem:hover span {\n  transform: translateX(5px);\n  color: #25C9D0;\n\n}\n\n.listheading span {\n  color: #343232;\n  font-size: 16px;\n  font-weight: 400;\n  margin-bottom: 4px;\n}\n\n.travelHelp {\n  bottom: 0;\n  width: 100%;\n  margin-top: 8rem;\n}\n\n.travelHelpcontainer {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.travelHelp .hedding h2 {\n  color: #2A3950;\n  font-size: 18px;\n  font-weight: 600;\n\n}\n\n.h6-title {\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.travelHelp .listButton {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);\n  margin-bottom: 10px;\n  font-size: 14px;\n  padding: 10px 18px;\n  display: table-cell;\n  float: left;\n  width: 100%;\n}\n\n.travelHelp .listButton.active {\n  border: 1px solid #25C9D0;\n}\n\n.listdots .List {\n  display: flex;\n  width: 300px;\n  margin: 0 auto;\n}\n\n.chaticon img {\n  margin-right: 8px;\n}\n\n.chatIcon {\n  min-width: auto !important;\n}\n\n.chatIcon img {\n  width: 24px;\n}\n\n.chatBg {\n  background-color: #fff;\n  box-shadow: 0px 2px 6px #dfdfdf;\n  padding: 4px;\n  display: inline-grid;\n  border-radius: 0px 18px 18px 18px;\n  border: 1px solid #E7E7E7;\n  color: #171A1F;\n  padding-left: 12px;\n  padding-right: 12px;\n  padding-top: 8px;\n}\n\n\n.chatBg h6 {\n  font-size: 15px;\n  color: #2A3950;\n  margin-bottom: 4px;\n}\n\n.chatBg .clr-grey {\n  color: #999;\n  font-size: 11px;\n}\n\n.chatBg2 {\n  background-color: #fff;\n  box-shadow: 0px 2px 6px #dfdfdf;\n  padding: 14px;\n  border-radius: 18px 0px 18px 18px;\n  display: inline-grid;\n  float: right;\n\n  h6 {\n    font-size: 15px;\n    color: #2A3950;\n  }\n\n  p {\n    font-size: 12px;\n    margin: 0px;\n  }\n\n  p .clr-grey {\n    color: #999;\n  }\n}\n\n.nav-right {\n  box-shadow: 1px 1px 5px #e0e0e0 !important;\n}\n\n.listdots .dots {\n  height: 8px;\n  background: #D6D4D2;\n  border-radius: 10px;\n  margin: 0 3px;\n  padding: 0;\n\n}\n\n.listdots .dots:hover {\n  background: #25C9D0;\n}\n\n.listdots .dots.active {\n  background: #25C9D0;\n}\n\n.hellowSection .icon {\n  width: 82px;\n  height: 82px;\n  background: #fff;\n  border-radius: 50%;\n  line-height: 75px;\n  margin: 12px auto;\n}\n\n.hellowSection h1 {\n  color: #2A3950;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 30px;\n}\n\n\n\n.footerSection {\n  background: #fff;\n  width: calc(100% - 240px);\n  padding: 20px;\n  position: fixed;\n  bottom: 0;\n}\n\n.grid-scroll {\n  overflow: scroll;\n  min-height: 440px;\n}\n\n.footerSection form {\n  display: flex;\n  height: 56px;\n  padding: 20px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 16px;\n  border: 1px solid #E7E7E7;\n  background: #F3F3F3;\n}\n\n.footerSection form input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  font-size: 14px;\n  color: #2A3950;\n}\n\n.footerSection form .typeBtn {\n  background: url('/src/assets/img/formBtn.svg') #25C9D0 no-repeat center center;\n  min-width: 32px;\n  height: 32px;\n\n}\n\n.tripDetails {\n  padding: 0 !important;\n  margin-bottom: 20px;\n  border: 1px solid rgb(0 0 0 / 20%);\n  border-radius: 6px !important;\n  overflow: hidden;\n  transition: all .2s ease-in-out;\n  height: 187px;\n\n}\n\n.tripDetails .tripImg {\n  overflow: hidden;\n  height: 100%;\n}\n\n.tripDetails .tripImg img {\n  width: 100%;\n  height: 100%;\n  transition: transform 0.3s ease-in-out;\n  object-fit: fill;\n}\n\n.tripDetails .tripImg img:hover {\n  transform: scale(1.1);\n}\n\n.tripDetails .details {\n  padding-left: 20px;\n}\n\n.tripDetails .details h2 {\n  color: #000;\n  font-weight: 500;\n  font-size: 17px;\n  line-height: 25px;\n  margin-bottom: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.infoText {\n  font-size: 13px;\n  color: #000;\n}\n\n.infoText .icon {\n  font-size: 16px;\n  margin-right: 5px;\n  color: #000;\n}\n\n.infoText .icon.date {\n  color: #db487e;\n  margin-bottom: 0px;\n}\n\n.infoText .dealDates {\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  line-height: 14px;\n  color: #000;\n  border: 2px solid #25C9D0;\n  border-radius: 5px;\n  padding: 0.5rem 1.1rem;\n  background: #ffffff;\n  text-transform: math-auto;\n}\n\n.infoText .dealDates:hover,\n.infoText .dealDates:active {\n  background-color: #25C9D0 !important;\n  color: #fff !important;\n  border-color: #23cad3 !important;\n}\n\n.infoText .location,\n.infoText .rating,\n.infoText .date {\n  margin-bottom: 12px;\n  font-size: 13px;\n  line-height: 16px;\n  color: #000;\n\n\n}\n\n.rightDetails {\n  font-size: 12px;\n  text-align: center;\n  background-color: #f6f6f6;\n  height: 100%;\n  border-right: 1px solid #dbdbdb;\n  font-size: 11px;\n  color: #000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rightDetails p {\n  margin: 0;\n}\n\n.book-btn {\n  background: #23cad3 !important;\n  color: #000 !important;\n  border-color: #23cad3 !important;\n}\n\n.rightDetails .book-btn {\n  height: 2.7em;\n  font-size: 13px;\n  border: 1px solid #25C9D0;\n  border-radius: 5px;\n  line-height: normal;\n  margin-top: 10px;\n  text-transform: math-auto;\n\n}\n\n.price-h5 {\n  font-size: 20px;\n  line-height: 23px;\n  color: #db487e;\n  margin: 5px 0;\n  display: block;\n}\n\n.nextbtn,\n.nextbtn:hover {\n  border-radius: 8px !important;\n  background: #25C9D0 !important;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25) !important;\n  color: #fff !important;\n}\n\n.custom-scroll {\n  overflow-y: scroll !important;\n}\n\n.custom-scroll::-webkit-scrollbar,\n.react-chatbot-kit-chat-message-container::-webkit-scrollbar {\n  width: 3px !important;\n}\n\n.custom-scroll::-webkit-scrollbar-track,\n.react-chatbot-kit-chat-message-container::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 18px rgba(250, 250, 251, 0.3);\n  -webkit-border-radius: 5px;\n  border-radius: 2px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n\n}\n\n.custom-scroll::-webkit-scrollbar-thumb,\n.react-chatbot-kit-chat-message-container::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 5px;\n  border-radius: 5px;\n  background-color: #dfe2e6 !important;\n  width: 6px !important;\n}\n\n.custom-scroll::-webkit-scrollbar-thumb:hover,\n.react-chatbot-kit-chat-message-container::-webkit-scrollbar-thumb:hover {\n  background: #757d85;\n}\n\n.aiChatbot .chatbotList {\n  max-width: 500px;\n  margin: 50px auto;\n  margin-top: 25px;\n\n}\n\n.aiChatbot .chatbotList li {\n  border-radius: 12px;\n  background: #FFF;\n  align-items: center;\n  display: flex;\n  list-style: none;\n  gap: 15px;\n  position: relative;\n  border: solid 1px #fff;\n}\n\n.aiChatbot .chatbotList li .icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 9px;\n  background: #e8f1fc;\n  width: 48px;\n  height: 48px;\n  transition: transform 0.3s ease-in-out;\n}\n\n.aiChatbot .chatbotList li .icon img {\n  margin: 0 auto;\n  border-radius: 30%;\n}\n\n.aiChatbot .chatbotList li:nth-child(1) .icon img {\n  width: 20px;\n}\n\n.aiChatbot .chatbotList li:nth-child(2) .icon img {\n  width: 15px;\n}\n\n.aiChatbot .chatbotList li:nth-child(3) .icon img {\n  width: 32px;\n}\n\n.aiChatbot .chatbotList li p {\n  color: #171A1F;\n  font-size: 13px;\n  transition: transform 0.3s ease-in-out;\n\n}\n\n.aiChatbot .chatbotList li:hover {\n  border: 1px solid #25C9D0;\n  box-shadow: 0px 0px 1px 0px rgba(23, 26, 31, 0.07), 0px 0px 2px 0px rgba(23, 26, 31, 0.12);\n  cursor: pointer;\n}\n\n.aiChatbot .chatbotList li:hover:after {\n  display: block;\n  content: \"\";\n  background-image: url(./assets/img/list-arrowright.png);\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  right: 15px;\n  animation: shake 1s cubic-bezier(.36, .07, .19, .97) both;\n\n}\n\n.aiChatbot .chatbotList li:hover p {\n  transform: translateX(-10px);\n}\n\n.aiChatbot .chatbotList li:hover .icon {\n  animation: shake 1s cubic-bezier(.36, .07, .19, .97) both;\n}\n\n.aiChatbot .chatbotList li:hover .icon {\n  color: #fff;\n}\n\n.aiChatbot h1 {\n  color: #171A1F;\n  font-size: 20px;\n  font-weight: 700;\n  text-align: center;\n}\n\n@keyframes shake {\n\n  10%,\n  90% {\n    transform: translate3d(-0.5px, 0, 0);\n  }\n\n  20%,\n  80% {\n    transform: translate3d(1px, 0, 0);\n  }\n\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-2px, 0, 0);\n  }\n\n  40%,\n  60% {\n    transform: translate3d(2px, 0, 0);\n  }\n}\n\n.contentSection {\n  height: calc(100vh - 100px);\n  padding-bottom: 14px;\n}\n\n\n\n.customChip {\n  font-size: 12px !important;\n}\n\n.customChip:hover {\n  box-shadow: inset 305px 0px 0px #25C9D0;\n  color: #ffffff;\n\n}\n\n.customCalender legend {\n  display: none;\n}\n\n.customCalender label,\n.customRadio label {\n  font-size: 14px;\n}\n\n.customCalender fieldset {\n  border-color: #25C9D0;\n}\n\n.customCalender fieldset {\n  padding: 8px;\n  padding-top: 5px;\n}\n\n.customCalender input {\n  padding: 8px;\n  padding-top: 4px;\n  font-size: 14px;\n}\n\n.customRadio .days {\n  border-radius: 4px;\n  border: 1px solid #25C9D0;\n  background: #FFF;\n  padding-right: 6px;\n  position: relative;\n  top: -4px;\n  margin-left: 0;\n  margin-right: 7px;\n}\n\n.customRadio .days span:nth-child(1) svg {\n  width: 15px;\n}\n\n.customRadio .days span:nth-child(1) {\n  padding: 4px;\n}\n\n.customRadio .days span:nth-child(2) {\n  font-size: 14px;\n}\n\n.customSubmit {\n  border-radius: 4px;\n  border: 1px solid #25C9D0;\n  background: rgba(68, 160, 188, 0.05);\n  color: #25C9D0;\n  transition: all 0.5s;\n  cursor: pointer;\n  width: 34px;\n  height: 34px;\n  text-align: center;\n  line-height: 30px;\n  margin-top: 27px;\n}\n\n.customSubmit .arrowIcon {\n  display: inline-block;\n  min-width: auto;\n  padding: 0;\n\n}\n\n.customSubmit .arrowIcon:hover {\n  animation: moveRight 1s infinite;\n}\n\n@keyframes moveRight {\n  0% {\n    transform: translateX(0);\n  }\n\n  50% {\n    transform: translateX(5px);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\n\n.customCheckBox {\n  height: 32px;\n  color: rgba(0, 0, 0, 0.87);\n  background: #fff;\n  margin-right: 10px;\n  display: inline-block;\n  border-radius: 32px;\n  font-size: 12px;\n  text-wrap: nowrap;\n  align-items: center;\n  padding-left: 7px;\n  padding-right: 13px;\n}\n\n\n.customCheckBox span {\n  padding: 0;\n}\n\n.customCheckBox svg {\n  width: 16px !important;\n}\n\n.btn_submit {\n  padding: 8px 16px !important;\n  border-radius: 16px !important;\n  border: 1px solid #25C9D0 !important;\n  background: #25C9D0 !important;\n  font-size: 12px !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n}\n\n.rightSide {\n  width: 100%;\n  position: relative;\n}\n\n.rightSideChat .chaticon {\n  background: #fff;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  line-height: 30px;\n  text-align: center;\n  margin-left: 8px;\n\n}\n\n.rightSideChat .chaticon img {\n  max-width: 60px;\n  margin-right: 0;\n  display: inline-block;\n}\n\n\n/* New chat css  */\n\n.options {\n  padding-bottom: 15px;\n}\n\n.options .options-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.options .options-container .option-item {\n  display: inline-flex;\n  padding: 5px 6px 5px 8px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 9px;\n  background: #E4E4E4;\n  color: #565E6C;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  margin-right: 4px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  border: solid 1px #E4E4E4;\n}\n\n.item-active {\n  color: #25C9D0 !important;\n  border: solid 1px #25C9D0 !important;\n  background: #fff !important;\n\n}\n\n.options .options-container .option-item:hover {\n  color: #25C9D0;\n  border: solid 1px #25C9D0;\n  background: #fff;\n}\n\n.options .options-header {\n  border-radius: 9px;\n  background: #f0f1ff;\n  display: inline-flex;\n  padding: 6px 8px;\n  color: #6d7fdc;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.popularPlaces h6 {\n  color: #db487e;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n  font-weight: bold;\n  margin-top: 8px;\n}\n\n.pplist {\n  padding: 0;\n  margin: 0;\n  color: #25C9D0;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 11px;\n  cursor: pointer;\n  text-align: left;\n  list-style: none;\n\n\n}\n\n.pplist li {\n  position: relative;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 90%;\n  margin-bottom: 8px;\n\n}\n\n.pplist li a {\n  color: #000;\n  text-decoration: none !important;\n}\n\n.pplist li:hover a {\n  color: #db487e;\n}\n\n.pplist li .placesIcon {\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  background: #25C9D0;\n  border-radius: 50%;\n  position: relative;\n  top: -2px;\n  margin-right: 2px;\n  transition: background-color 0.5s ease, width 0.5s ease, border-radius 0.5s ease;\n\n\n}\n\n.pplist li:hover .placesIcon {\n  width: 16px;\n  height: 5px;\n  background: #db487e;\n  border-radius: 8px;\n  transition: background-color 0.5s ease, width 0.5s ease, border-radius 0.5s ease;\n\n}\n\n.rightSide .vertical-lines {\n  position: absolute;\n  top: 100px;\n  right: 0;\n  margin-right: 12px;\n  cursor: pointer;\n  z-index: 1;\n  display: inline-block;\n}\n\n.rightSide .vertical-lines .lines {\n  border-radius: 9999px;\n  height: 16px;\n  width: 4px;\n  background-color: #25C9D0;\n  cursor: pointer;\n}\n\n.rightSide .vertical-lines .lineOne {\n  transform: translateY(0.15rem) rotate(0deg);\n}\n\n.rightSide .vertical-lines .lineTwo {\n  transform: translateY(-0.15rem) rotate(0deg);\n}\n\n.rightSide .vertical-lines:hover .lineOne {\n  transform: translateY(0.15rem) rotate(-15deg) !important;\n}\n\n.rightSide .vertical-lines:hover .lineTwo {\n  transform: translateY(-0.15rem) rotate(15deg) translateZ(0px) !important;\n\n  position: relative;\n  top: 3px;\n}\n\n.rightSide .vertical-lines:hover::after {\n  content: \"Close sidebar\";\n  position: absolute;\n  background-color: #000;\n  font-size: 12px;\n  color: #fff;\n  padding: 5px 8px;\n  border-radius: 5px;\n  text-align: center;\n  margin-bottom: 10px;\n  top: 0;\n  right: 16px;\n  text-wrap: nowrap;\n}\n\n.rightSide .vertical-lines:hover::before {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-width: 0px 8px 8px 8px;\n  border-color: #000 transparent;\n  display: block;\n  width: 0;\n  z-index: 1;\n  transform: rotate(90deg);\n  bottom: 13px;\n  left: -18px;\n}\n\n.rightBarFull .vertical-lines:hover::after {\n  content: \"Open sidebar\";\n\n}\n\n.rightBarFull .vertical-lines .lineOne,\n.rightBarFull .vertical-lines:hover .lineOne {\n  transform: translateY(.15rem) rotate(15deg) !important;\n}\n\n.rightBarFull .vertical-lines .lineTwo,\n.rightBarFull .vertical-lines:hover .lineTwo {\n  transform: translateY(.15rem) rotate(-15deg) !important;\n  position: relative;\n  top: -3px;\n}\n\n\n.rightBarFull .react-chatbot-kit-chat-input-container {\n  width: calc(100% - 16px);\n}\n\n.yourOrigin .custom_Autocomplete {\n  width: 200px;\n}\n\n@media (min-width:992px) and (max-width:1024px) {\n  .yourOrigin .custom_Autocomplete {\n    width: 150px;\n  }\n\n  .yourOrigin .custom_Autocomplete [class*=\"MuiAutocomplete-root\"] {\n    padding-right: 25px !important;\n  }\n\n}\n\n.yourOrigin .MuiInputBase-formControl::before,\n.yourOrigin .MuiInputBase-formControl::after {\n  display: block;\n  content: \"\";\n  width: 18px;\n  height: 18px;\n  background-size: contain !important;\n}\n\n.yourOrigin .MuiInputBase-formControl::before {\n\n  background: url('/src/assets/img/location-fill.png') no-repeat;\n}\n\n.yourOrigin .MuiInputBase-formControl::after {\n  background: url('/src/assets/img/iconamoon_search.png') no-repeat;\n  position: absolute;\n  right: 8px;\n}\n\n.yourOrigin .MuiAutocomplete-clearIndicator {\n  position: relative;\n  right: 24px;\n  display: none;\n}\n\n.yourOrigin .MuiAutocomplete-popupIndicator {\n  display: none;\n}\n\n\n.yourOrigin fieldset {\n  border-radius: 8px;\n}\n\n.css-gdh49b-MuiAutocomplete-listbox .MuiAutocomplete-option {\n  font-size: 14px;\n\n}\n\n.css-gdh49b-MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused {\n  background-color: rgb(68 160 188 / 20%) !important;\n}\n\n.weather-condition-popover .ulList {\n  padding-bottom: 10px !important;\n\n}\n\n.weather-condition-popover .weather-place-title {\n  background: #db487e;\n  height: 16px;\n}\n\n.weather-condition-popover li span {\n  font-size: 13px;\n}\n\n.TooltipTitle {\n  color: #db487e !important;\n}\n\n.demo-simple-select-label {\n  position: relative;\n  top: 5px;\n  left: 10px;\n  background: #fff;\n  z-index: 1;\n  display: block;\n  width: 68px;\n  font-size: 13px !important;\n}\n\n#header-container {\n  padding: 8px 0;\n}\n\n.WeatherReportSection {\n  border-bottom: solid 1px solid 1px rgb(0 0 0 / 30%);\n  background-color: #F6FFFF;\n  color: #000;\n  padding: 16px;\n  border-radius: 8px;\n  position: relative;\n}\n\n.WeatherReportSection::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: -10px;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 10px solid #F6FFFF;\n  transform: translateY(-50%);\n}\n\n.placesListSection {\n  padding: 16px;\n  border-bottom: solid 1px solid 1px rgb(0 0 0 / 30%);\n  background-color: #F6FFFF;\n  color: #000;\n  border-radius: 8px;\n  position: relative;\n}\n\n.placesListSection::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: -10px;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 10px solid #F6FFFF;\n  transform: translateY(-50%);\n\n\n}\n\n@media screen and (max-width:900px) {\n\n  .WeatherReportSection {\n    right: -18px !important;\n    border-radius: 5px;\n\n  }\n\n  .placesListSection::before {\n    content: \"\";\n    position: inherit;\n    top: none;\n    left: none;\n    border-top: none;\n    border-bottom: none;\n    border-right: none;\n    transform: none;\n  }\n\n\n  .placesListSection::after {\n    content: \"\";\n    position: absolute;\n    bottom: -14px;\n    right: 14px;\n    border-top: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n    border-right: 10px solid #F6FFFF;\n    transform: translateY(50%);\n    rotate: -90deg;\n  }\n\n  .placesListSection {\n    bottom: -10px !important;\n    border-radius: 2px;\n\n  }\n\n}\n\n@media screen and (max-width:768px) {\n  .WeatherReportSection {\n    right: -25px !important;\n  }\n}\n\n\n.WeatherReportSection .avg-title {\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.WeatherReportSection .weatherConditions {\n  position: relative;\n}\n\n.WeatherReportSection .weatherConditions .btn-arrow {\n  font-size: 12px;\n  top: 9px;\n  left: -9px;\n}\n\n.WeatherReportSection .destinationName {\n  width: 75px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n}\n\n.WeatherReportSection .precipitationValue {\n  color: #25C9D0;\n  font-size: 16px;\n}\n\n.btn-cancel {\n  opacity: 1;\n  color: #000;\n  border-radius: 50%;\n  margin: 0 0 0 auto;\n  text-decoration: none;\n  cursor: pointer;\n\n}\n\n.captchaSection {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.results-card {\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  background: #ffffff;\n  line-height: 1.4;\n  font-family: Roboto, Helvetica Neue, sans-serif;\n  border-radius: 0;\n  overflow: hidden;\n  z-index: 0;\n}\n\n@media (min-width: 769px) {\n  .results-card {\n    flex-direction: row;\n  }\n}\n\n.results-card .description {\n  flex-basis: 70%\n}\n\n.results-card .meta {\n  flex-basis: 30%\n}\n\n.AccordionDetails {\n  padding: 0 !important;\n}\n\n.price-disclmr-note {\n  font-size: 9px;\n  padding: 0px;\n  margin: 0px;\n  display: block;\n}\n\n\n/* Bouncing Loader */\n.bouncing-loader {\n  display: flex;\n  justify-content: center;\n  margin: 40px auto;\n}\n\n.bouncing-loader>div {\n  width: 12px;\n  height: 12px;\n  margin: 2px 5px;\n  border-radius: 50%;\n  background-color: #a3a1a1;\n  opacity: 1;\n  animation: bouncing-loader 0.6s infinite alternate;\n  margin-top: 8px;\n}\n\n@keyframes bouncing-loader {\n  to {\n    opacity: 0.1;\n    /* transform: translateY(-16px); */\n    transform: translateY(-10px);\n  }\n}\n\n.bouncing-loader>div:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.bouncing-loader>div:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n.bouncing-loader-conditional-cls {\n  justify-content: flex-start;\n  margin: 10px auto;\n  margin-bottom: 4px;\n}\n\n/*** RWD css ***/\n\n\n/* Mobile devices */\n\n@media (max-width: 575px) {\n  .tripDetails .details {\n    padding-bottom: 8px;\n  }\n\n  .tripDetails .details h2 {\n    font-size: 14px;\n    white-space: unset;\n    line-height: 22px;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .header-section .logo img {\n    width: 80px;\n  }\n\n  .header-section .btn-cancel {\n    display: none;\n  }\n\n  .hero-section .home-heading {\n    font-size: 1.5rem;\n    line-height: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  .yourOrigin .custom_Autocomplete {\n    width: 150px;\n  }\n\n  .yourOrigin .custom_Autocomplete .MuiAutocomplete-input {\n    padding: 1px !important;\n    font-size: 12px;\n  }\n\n  .aiChatbot .chatbotList {\n    max-width: 100%;\n  }\n\n  .react-chatbot-kit-chat-bot-message-container,\n  .react-chatbot-kit-user-chat-message {\n    max-width: 80% !important;\n  }\n\n}\n\n@media (max-width: 992px) {\n\n  .tripDetails {\n    height: auto;\n    overflow: auto;\n  }\n\n  .leftSideBar.open {\n    position: absolute;\n    right: 0;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n\n  }\n\n  .vertical-lines-mobile {\n    display: none !important;\n  }\n\n}\n\n@media (max-width: 1199.98px) {\n  #header-container.container {\n    max-width: 100% !important;\n    padding: 8px 16px !important;\n  }\n\n  .travelHelpcontainer {\n    width: 100%;\n  }\n}\n\n\n/* xxl  applies to x-large devices (large desktops, less than 1400px) */\n@media (max-width: 1399.98px) {}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\niframe {\n  display: none !important;\n}\n\n::-webkit-scrollbar {\n  /* width: 3px !important; */\n}\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 18px rgba(250, 250, 251, 0.3);\n  -webkit-border-radius: 5px;\n  border-radius: 2px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n\n}\n\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 5px;\n  border-radius: 5px;\n  background-color: #dfe2e6 !important;\n  width: 6px !important;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #757d85;\n}\n\n.disabledDiv {\n  pointer-events: none !important;\n  opacity: 0.8 !important;\n}\n\n.margin-top-100 {\n  margin-top: 78px;\n}\n\n@media screen and (max-width:768px) {\n  .margin-top-100 {\n    margin-top: 61px;\n  }\n}\n\n.AIslider-plus-item {\n  width: 100%;\n  /* min-height: 300px !important; */\n  min-height: 460px !important;\n\n  background-color: #F6F6F6 !important;\n}\n\n.plus-btn-class {\n  border: 0px !important;\n  background-color: transparent !important;\n  cursor: pointer !important;\n}\n\n.plus-link-btn {\n  text-decoration: none !important;\n  cursor: pointer !important;\n\n}\n\n\n\n.disable-select {\n  user-select: none;\n  -webkit-touch-callout: none;\n}\n\n.AIslider-plus-item {\n  width: 100%;\n  min-height: 440px !important;\n  background-color: #ffffff !important;\n}\n\n.plus-btn-class {\n  border: 0px !important;\n  background-color: transparent !important;\n}\n\n.plus-link-btn {\n  text-decoration: none !important;\n  background-color: transparent !important;\n  border: 0px !important;\n\n}\n\n.plus-btn-card-class {\n  width: 245px;\n  /* height: 190px; */\n  border-radius: 10px;\n  border: 2px;\n  background-color: #EEFEFF;\n  border-color: #25C9D0;\n  border-style: dashed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n}\n\n.show-more-packages-btn-class {\n  background-color: transparent;\n  border: 2px solid #25C9D0;\n  border-radius: 5px;\n  color: #1ABCC3;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.show-more-packages-paragraph-class {\n  color: #1ABCC3;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.preferences-radio-btn-class span {\n  font-size: 12px !important;\n  color: #565E6C !important;\n  font-weight: 400 !important;\n}\n\n.ai-preferences-options {\n  background: rgb(255, 255, 255);\n  border-radius: 10px;\n}\n\n.react-datepicker-container-class .react-datepicker {\n  width: 100% !important;\n  border: 0px !important;\n}\n\n.react-datepicker-container-class .react-datepicker .react-datepicker__month-container {\n  float: none !important;\n}\n\n@media screen and (min-width:576px) and (max-width:767px) {\n  .plus-btn-card-class {\n    width: 205px;\n  }\n}\n\n@page {\n  size: auto;\n  margin: 20px;\n  border-radius: 16px;\n  background: #F5F6FA;\n  padding-bottom: 16px;\n  padding-top: 30px;\n  padding-left: 20px;\n  position: relative;\n  flex: 1 1 auto;\n}\n\n@media print {\n  .row {\n    --bs-gutter-x: 1.5rem;\n    --bs-gutter-y: 0;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(-1* var(--bs-gutter-y));\n    margin-right: calc(-0.5* var(--bs-gutter-x));\n    margin-left: calc(-0.5* var(--bs-gutter-x));\n  }\n\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .heading-grid {\n    color: #000;\n    font-size: 14px;\n    margin-bottom: 24px;\n    margin-left: 1.5rem;\n  }\n\n  .gap-3 {\n    gap: 1rem !important;\n  }\n\n  .d-flex {\n    display: flex !important;\n  }\n\n  .custom-stepper {\n    width: 100%;\n  }\n\n  .custom-stepper .stepper-item {\n    list-style: none;\n    height: 100%;\n    position: relative;\n    width: 100%;\n  }\n\n  .custom-stepper .stepper-item::after {\n    content: '';\n    height: 100%;\n    border: dashed 1px rgb(0 0 0 / 50%);\n    width: 1px;\n    display: block;\n    position: absolute;\n    top: 17px;\n    left: 12px;\n  }\n\n  .custom-stepper .stepper-item .stepper-icon .icon {\n    z-index: 1;\n    position: relative;\n    width: 26px;\n    height: 26px;\n    border-radius: 20px;\n    background-color: #DB487E;\n    color: #fff;\n    text-align: center;\n  }\n\n  .custom-stepper .stepper-item .stepper-icon .icon:before {\n    z-index: 0;\n    content: '';\n    position: absolute;\n    top: 19px;\n    left: 50%;\n    margin-left: -12px;\n    border-left: 12px solid transparent;\n    border-right: 12px solid transparent;\n    border-top: 20px solid #DB487E;\n  }\n\n  .custom-stepper .stepper-item .stepper-icon .icon span {\n    position: relative;\n    top: 5px;\n    font-size: 13px;\n  }\n\n  .custom-stepper .last-item::after {\n    display: none !important\n  }\n\n\n  .dragging-box .custom-stepper .stepper-item::after {\n    display: none !important\n  }\n\n  .dragging-box .custom-stepper .stepper-item .trip-duration {\n    display: none !important\n  }\n\n  .dragging-box .custom-stepper .stepper-item .stepper-content .trip-card .description {\n    border-color: #25C9D0;\n  }\n\n  .custom-stepper .stepper-item .stepper-content {\n    width: 100%;\n  }\n\n  .custom-stepper .stepper-item .stepper-content::after {\n    content: '';\n    height: 100%;\n    width: 2px;\n    background-color: red;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card {\n    display: flex;\n    flex-direction: row;\n    margin: 0 auto;\n    line-height: 1.4;\n    border-radius: 0;\n    overflow: hidden;\n    z-index: 0;\n  }\n\n  @media (min-width: 769px) {\n    .custom-stepper .stepper-item .stepper-content .trip-card {\n      flex-direction: row;\n    }\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description {\n    flex-basis: 85%;\n    background: #fff;\n    border-radius: 16px;\n    border: 1px solid #E4E4E4;\n    background: #FFF;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .meta {\n    flex-basis: 15%\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description h2 {\n    color: #DB487E;\n    text-align: center;\n    font-size: 0.9em;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .draggable-icon {\n    position: absolute;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .title {\n    color: #000;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 16.412px;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .dec {\n    color: #4A4A4A;\n    font-size: 12px;\n    font-weight: 400;\n    letter-spacing: 0.15px;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .price-book {\n    position: relative;\n    top: 50%;\n    transform: translate(0%, -50%);\n    align-items: center;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .price-book .price {\n    color: #DB487E;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 16.412px;\n    margin-bottom: 8px;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .price-book .book-btn {\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16.412px;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .border-right {\n    border-right: solid 1px #DFDFDF;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons {\n    position: relative;\n    color: #7A7C7D;\n    font-size: 12px;\n    font-weight: 400;\n    margin-right: 16px;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons .activity-time {\n    color: #000;\n    text-align: center;\n    font-size: 12px;\n    font-weight: 600;\n    margin: 10px 0\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons::before {\n    content: \"\";\n    display: block;\n    height: 62%;\n    position: absolute;\n    top: 16px;\n    left: 7px;\n    border: dashed 1px #DFDFDF;\n    margin-right: 0;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons .timer-bottom,\n  .custom-stepper .stepper-item .stepper-content .trip-card .description .timer-icons .timer-top {\n\n    font-size: 15px;\n    color: #DB487E;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .meta .image-grid {\n    border-radius: 16px;\n    border: 1px solid #E4E4E4;\n    overflow: hidden;\n    position: relative;\n    width: 190px;\n    height: 137px;\n    transition: transform 0.3s ease-in-out;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.5);\n\n      img {\n        transform: scale(1.1);\n      }\n    }\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .meta .image-grid img {\n    width: 100%;\n    height: 100%;\n    transition: transform 0.3s ease-in-out;\n\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .meta .image-grid .image-info {\n    position: absolute;\n    bottom: 0;\n    padding: 8px;\n    width: 100%;\n    border-radius: 0px 0px 16px 16px;\n    background: rgb(0 0 0 / 50%);\n    color: #FFF;\n    font-size: 11px;\n    font-weight: 400;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .meta .del-edit-icons {\n    width: 16px;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card:hover .meta .del-edit-icons {\n    width: 16px;\n    opacity: 1;\n    visibility: visible;\n  }\n\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .meta .del-edit-icons button {\n    min-width: auto;\n    padding: 0;\n    font-size: 20px;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .meta .del-edit-icons .btn-del-icon {\n    width: 20px;\n    height: 20px;\n    color: #DB487E;\n  }\n\n\n\n  .custom-stepper .stepper-item .stepper-content .trip-card .meta .del-edit-icons .btn-edit-icon {\n    color: #4dd2d7;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-duration {\n    color: #070F1D;\n    font-size: 14px;\n    font-weight: 400;\n    height: 70px;\n    position: relative;\n    padding-top: 25px;\n    padding-left: 129px;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-duration::before {\n    content: \"\";\n    height: 100%;\n    display: block;\n    position: absolute;\n    top: 50%;\n    transform: translate(0%, -50%);\n    border: dashed 1px #C2C2C2;\n    width: 1px;\n  }\n\n\n  .custom-stepper .stepper-item .stepper-content .trip-duration .car {\n    width: 36px;\n    height: 20px;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-duration .wheel {\n    position: relative;\n    animation: spin 5s linear infinite;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-duration .wheel-one {\n    left: 2px;\n    top: 11px;\n    animation: spin 5s linear infinite;\n    position: relative;\n  }\n\n  .custom-stepper .stepper-item .stepper-content .trip-duration .wheel-two {\n    left: -2px;\n    top: 11px;\n    position: relative;\n    animation: spin 5s linear infinite;\n\n  }\n\n}\n\n.disable-del-edit-icons {\n  display: none !important;\n  opacity: 0 !important;\n}\n\n@media screen and (min-width:993px) {\n  .trip-mobile-menu-icon {\n    display: none;\n  }\n}\n\n@media screen and (max-width:450px) {\n  .mobile-padding-cls {\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n\n  }\n}\n\n\n.highlight-card {\n  border: 2px solid #007bff;\n  background: #f0f8ff;\n}\n.button.chatbot-chat-btn-send.mic-icon {\n  right: 46px;\n}\n\n/* .button.chatbot-chat-btn-send.mic-icon svg {\n  font-size: 20px;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
